// src/application.js
import { Application } from "@hotwired/stimulus"

const application = Application.start()

application.debug = true // FIXME: configure for production
window.dummyStimulus = application

export { application };